export enum DebtsAccessRulesKeyEnum {
  // --- Модуль DEBTS (Задолженности) ---
  // --- Раздел DEBTS.SECTIONS.DEBTS (Задолженности) ---

  // Вкладки
  DEBTS_DEBTS_DEBTORS_READ = 'DEBTS_DEBTS_DEBTORS_READ',

  DEBTS_DEBTS_CREDIT_READ = 'DEBTS_DEBTS_CREDIT_READ',

  DEBTS_DEBTS_DEBIT_READ = 'DEBTS_DEBTS_DEBIT_READ',

  DEBTS_DEBTS_BILL_REGISTRY_READ = 'DEBTS_DEBTS_BILL_REGISTRY_READ',

  DEBTS_DEBTS_AUTOCHECK_BILLS_WRITE = 'DEBTS_DEBTS_AUTOCHECK_BILLS_WRITE',

  DEBTS_DEBTS_MAILING_READ = 'DEBTS_DEBTS_MAILING_READ',
  DEBTS_DEBTS_MAILING_WRITE = 'DEBTS_DEBTS_MAILING_WRITE',

  DEBTS_DEBTS_CASH_GAP_READ = 'DEBTS_DEBTS_CASH_GAP_READ',

  DEBTS_DEBTS_CREDIT_DEBIT_EXCLUSION_READ = 'DEBTS_DEBTS_CREDIT_DEBIT_EXCLUSION_READ',
  DEBTS_DEBTS_CREDIT_DEBIT_EXCLUSION_WRITE = 'DEBTS_DEBTS_CREDIT_DEBIT_EXCLUSION_WRITE',

  DEBTS_DEBTS_DEBT_COLLECTION_READ = 'DEBTS_DEBTS_DEBT_COLLECTION_READ',
  DEBTS_DEBTS_DEBT_COLLECTION_WRITE = 'DEBTS_DEBTS_DEBT_COLLECTION_WRITE',

  DEBTS_DEBTS_INTEGRATION_EMAIL_READ = 'DEBTS_DEBTS_INTEGRATION_EMAIL_READ',
  DEBTS_DEBTS_INTEGRATION_EMAIL_WRITE = 'DEBTS_DEBTS_INTEGRATION_EMAIL_WRITE',

  DEBTS_DEBTS_INTEGRATION_MAIN_SMS_READ = 'DEBTS_DEBTS_INTEGRATION_MAIN_SMS_READ',
  DEBTS_DEBTS_INTEGRATION_MAIN_SMS_WRITE = 'DEBTS_DEBTS_INTEGRATION_MAIN_SMS_WRITE',

  // Разрешения
  DEBTS_DEBTS_DEBT_COLLECTION_READ_ALL_TASKS = 'DEBTS_DEBTS_DEBT_COLLECTION_READ_ALL_TASKS'
}
